import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEnvelope, faPhone, faMapMarkerAlt, faLink
} from '@fortawesome/free-solid-svg-icons';
import {
    faGithub, faLinkedin, faYoutube, faUpwork, faTelegram,
    faFacebook, faTwitter, faInstagram, faMedium, faBehance,
    faDribbble, faStackOverflow, faAngellist, faQuora,
    faVimeo, faSoundcloud
} from '@fortawesome/free-brands-svg-icons';
import '../styles/TemplateEleven.css'; // Ensure you have the appropriate CSS file

const TemplateEleven = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud,
        blog: faLink,         // Assume generic link icon
        researchgate: faLink, // Assume generic link icon
        devto: faLink        // Assume generic link icon
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud',
        blog: 'Blog',
        researchgate: 'ResearchGate',
        devto: 'Dev.to'
    };

    // Ensure links are an array
    const links = Array.isArray(template?.links) ? template.links : [];

    return (
        <div className="template-eleven-container" onClick={() => onClick(template?.id)}>
            <div className="template-eleven">
                <div className="template-eleven-left">

                    <div className="template-eleven-name">
                        {template?.name && <h1 className="template-eleven-name">{template?.name}</h1>}
                    </div>

                    <div className="template-eleven-aboutMe">
                        <div className="template-eleven-section">
                            <h3>About Me</h3>
                            {template?.aboutMe && <p className="template-eleven-aboutMe">{template?.aboutMe}</p>}
                        </div>
                    </div>

                    <div className="template-eleven-skills">
                        <div className="template-eleven-section">
                            <h3>Skills</h3>
                            <ul>
                                {template?.skills && template.skills.map((skill, index) => (
                                    <li key={index}>{skill}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="template-eleven-software-skills">
                        <div className="template-eleven-section">
                            <h3>Software Skills</h3>
                            <ul>
                                {template?.softwareSkills && template.softwareSkills.map((software, index) => (
                                    <li key={index}>{software}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="template-eleven-languages">
                        <div className="template-eleven-section">
                            <h3>Languages</h3>
                            <ul>
                                {template?.languages && template.languages.map((language, index) => (
                                    <li key={index}>{language}</li>
                                ))}
                            </ul>
                        </div>
                    </div>

                </div>
                <div className="template-eleven-right">

                    <div className="template-eleven-profile">
                        {template?.image && <img src={template.image} alt={template.personName} className="template-eleven-image" />}
                    </div>

                    <div className="template-eleven-contact">
                        {template?.contact && (
                            <div className="template-eleven-section">
                                <h3>Contact</h3>
                                {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                                {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                                {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                            </div>
                        )}
                    </div>
                    <div className="template-eleven-education">
                        <div className="template-eleven-section">
                            <h3>Education</h3>
                            {template?.education && template.education.map((edu, index) => (
                                <div key={index} className="template-eleven-education-item">
                                    <p className="template-eleven-degree">{edu.degree}</p>
                                    <p className="template-eleven-institution">{edu.institution}</p>
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    <p className="view-template-eight-institution">{edu.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="template-eleven-work-experience">
                        <div className="template-eleven-section">
                            <h3>Work Experience</h3>
                            {template?.workExperience && template.workExperience.map((experience, index) => (
                                <div key={index} className="template-eleven-experience-item">
                                    <p className="template-eleven-role">{experience.role}</p>
                                    <p className="template-eleven-company-location">{experience.company} / {experience.location}</p>
                                    <p className="template-eleven-date">
                                        {experience.location && (
                                            <p className="location">
                                                (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                    </p>
                                    <p className="template-eleven-description">{experience.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="template-eleven-certificates">
                        {template?.certificates && (
                            <div className="template-eleven-section">
                                <h3>Certificates</h3>
                                {template.certificates.map((certificate, index) => (
                                    <div key={index} className="template-eleven-certificate-item">
                                        <p className="template-eleven-title">Title: {certificate.title}</p>
                                        <p className="template-eleven-institution">Institution: {certificate.institution}</p>
                                        <p className="template-eleven-date">
                                            Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="template-eleven-hobbies">
                        {template?.hobbies && template.hobbies.length > 0 && (
                            <div className="template-eleven-section">
                                <h3>Hobbies</h3>
                                <ul>
                                    {template.hobbies.map((hobby, index) => (
                                        <li key={index}>{hobby}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="template-eleven-links">
                        {template.links && (
                            <div className="template-eleven-section">
                                <h3>Links</h3>
                                {template.links.map(([key, value]) => (
                                    <p key={key}>
                                        <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-three-link-text">{linkText[key]}</span></a>
                                    </p>
                                ))}
                            </div>
                        )}

                    </div>

                </div>
            </div>
        </div>
    );
};

export default TemplateEleven;
